import { Injectable } from "@angular/core";
import { Http, RequestOptions } from "@angular/http";

import { BehaviorSubject } from "rxjs";
import { CookieService } from "angular2-cookie/services/cookies.service";

import { ServiceUtilities } from './service-utilities';
import { CurrentUserService } from "../services/current-user.service";
import { QuoteInfoService } from "../services/quote-info.service";

@Injectable()
export class AuthDataService {
    tempRetailer$: BehaviorSubject<any> = new BehaviorSubject(null);

    cmhBaseUrl: string;
    mchBaseUrl: string;

    constructor(
        private http: Http,
        private cookie: CookieService,
        private currentUserService: CurrentUserService,
        private serviceUtils: ServiceUtilities,
        private quoteInfoService: QuoteInfoService
    ) {
        this.cmhBaseUrl = this.cookie.get('cmhBaseUrl');
        this.mchBaseUrl = this.cookie.get('mchBaseUrl');
    }

    get authUrlCookie() {
        return this.cookie.get('authUrl');
    }

    public changeRetailerNumber(retailerNumber: string) {
        let options: RequestOptions = this.serviceUtils.getStandardHeaderOptions();
        //let bearer = this.cookie.get('Bearer');
        //options.headers.append('authorization', `bearer ${bearer}`);
        return this.http.get(`${this.authUrlCookie}/api/Account/ChangeRetailerNumber?retailerNumber=${retailerNumber}`, options)
            .map(x => x.json())
            .catch(this.serviceUtils.handleError);
    }

    setRetailer(redirect?: boolean) {
        this.tempRetailer$.subscribe(temp => {
            this.changeRetailerNumber(temp.retailerNumber).subscribe(x => {
                this.currentUserService.setUserToken(x.bearerToken);
                this.currentUserService.setCurrentUser(x);
                return x;
            });
            let a;
            this.currentUserService.currentUser$.subscribe(x => {
                a = x;
                a.retailerName = temp.name;
                a.retailerNumber = temp.retailerNumber;
                return a;
            });
            this.currentUserService.currentUser$.next(a);
            this.toggleUserModal();
            this.currentUserService.userSet$.subscribe(x => {
                if (x === true) {
                    if (redirect) {
                        window.location.href = `${this.cmhBaseUrl}#!/sales/quotes`;
                    } else {
                        window.location.reload(true);
                    }
                }
            })
        });
    }

    setOptionsConfigRetailer() {
        this.tempRetailer$.subscribe(temp => {
            this.changeRetailerNumber(temp.retailerNumber).subscribe(x => {
                this.currentUserService.setUserToken(x.bearerToken);
                this.currentUserService.setCurrentUser(x);
                return x;
            });
            let a;
            this.currentUserService.currentUser$.subscribe(x => {
                a = x;
                a.retailerName = temp.name;
                a.retailerNumber = temp.retailerNumber;
                return a;
            });
            this.currentUserService.currentUser$.next(a);
            this.toggleUserModal();
            this.currentUserService.userSet$.subscribe(x => {
                if (x === true) {
                    window.location.href = `${this.mchBaseUrl}/options-admin/${a.retailerNumber}`;
                }
            })
        });
    }

    toggleUserModal() {
        let temp: boolean;
        this.quoteInfoService.showUserMenu$.subscribe(x => {
            temp = x;
        });
        this.quoteInfoService.showUserMenu$.next(!temp);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/auth-data.service.ts